import { render, staticRenderFns } from "./IconSquareEdit.vue?vue&type=template&id=69733318"
import script from "./IconSquareEdit.vue?vue&type=script&lang=js"
export * from "./IconSquareEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports